module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_ENSEIGNES_LE_TRAITEUR_LETTRE_A_LETTRE.a812e982.png";